import { getDate } from 'utility/Format/Date';

import { config } from '../__config';

export const getFormattedDate = (date?: Date) =>
    date && getDate(date, config.format, config.dateTimeFormatOptions);
